import { Component, input, output } from '@angular/core';
import { AppNotification } from '@legacy-models/strapi/AppNotification';
import { SvgIconComponent } from 'angular-svg-icon';

@Component({
  selector: 'oke-notification',
  imports: [SvgIconComponent],
  templateUrl: './notification.html',
  styleUrl: './notification.scss'
})
export class Notification {
  readonly $notification = input<AppNotification | null>(null, {
    alias: 'notification'
  });
  readonly clear = output<any>();

  clearAppNotification(): void {
    this.clear.emit({
      id: this.$notification()?.id,
      isPersist: this.$notification()?.isViewStatusSaved
    });
  }
}
